<template>
	<div class="workFlow">
		<div class="el-steps el-steps--horizontal" v-if="list.length > 0">
			<div
				v-for="(item, index) in list"
				:key="index"
				class="el-step is-horizontal is-center"
				style="flex-basis: 25%; margin-right: 0px"
			>
				<div
					class="el-step__head"
					:class="item.mark == 1 ? 'is-finish' : 'is-wait'"
				>
					<div class="el-step__line" style="margin-right: 0px">
						<i
							v-if="item.mark == 1"
							class="el-step__line-inner"
							style="transition-delay: 0ms; border-width: 1px; width: 100%"
						></i>
						<i
							v-else
							class="el-step__line-inner"
							style="transition-delay: 150ms; border-width: 0px; width: 100%"
						></i>
					</div>
					<div class="el-step__icon">
						<div class="el-step__icon-inner">⬤</div>
					</div>
				</div>
				<div class="el-step__main">
					<div
						class="el-step__description"
						:class="item.mark == 1 ? 'is-finish' : 'is-wait'"
					>
						{{ $utils.timeFormat(item.flowTime) }}
					</div>
					<div
						class="el-step__description"
						:class="item.mark == 1 ? 'is-finish' : 'is-wait'"
					>
						{{ item.vrepairFlowName }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: "workFlow",
	props: {
		list: {
			type: Array,
			default: () => [],
		},
	},
};
</script>
<style scoped lang="scss">
.el-step__description {
	margin-top: 5px;
}
</style>
